import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useKriterien } from "../../context/KriterienContext";
import styles from "./Kriterien.module.css";

const Kriterien = () => {
  const { data, setData } = useKriterien();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  const toggle = (field) => {
    setData((prev) => ({
      ...prev,
      [field]: prev[field] === "ja" ? "" : "ja",
    }));
  };

  const handleNext = () => {
    navigate("/kategorisierung");
  };

  const handleBack = () => {
    navigate("/fussstatusGrafik");
  };

  const rows = [
    {
      field: "orthopaedischeZusatzkomplikation",
      label: "a. Orthopädische Zusatzkomplikation",
    },
    {
      field: "neurologischeZusatzkomplikation",
      label: "b. Neurologische Zusatzkomplikation (motorische Funktionseinschränkung / Parese eines oder beider Beine)",
    },
    {
      field: "fehlgeschlageneVorversorgung",
      label: "c. Fehlgeschlagene adäquate Vorversorgung",
    },
  ];

  const selectedLabels = rows
    .filter((row) => data[row.field] === "ja")
    .map((row) => row.label);

  const showWarning = selectedLabels.length > 0;

  const warningText = showWarning
    ? `Sie sollten aufgrund Ihrer Auswahl (${selectedLabels.join(", ")}) Ihre Auswahl erweitern oder Rücksprache mit einer Ärztin / einem Arzt halten.`
    : "";

  return (
    <div className={styles["kriterien-page"]}>
      <h1>Kriterien für eine höhergradige Versorgung</h1>

      <table className={styles["kriterien-table"]}>
        <thead>
          <tr>
            <th></th>
            <th>✓</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.field}
              className={styles["kriterien-row"]}
              onClick={() => toggle(row.field)}
            >
              <td>{row.label}</td>
              <td className={styles["checkbox-cell"]}>
                <input
                  type="checkbox"
                  checked={data[row.field] === "ja"}
                  onChange={() => toggle(row.field)}
                  onClick={(e) => e.stopPropagation()}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showWarning && (
        <div className={styles["kriterien-advisory"]}>
          {warningText}
        </div>
      )}

      {/* KRITERIEN – NOTIZ  */}
      <div className={styles.row}>
        <div className={styles["col-sm-4"]}>
          <label className={styles.label}>Kriterien – Notiz</label>
          <p className={styles["note-hint"]}>
            Hier kann eine Notiz für zusätzliche Einzelheiten geschrieben werden.
          </p>
        </div>
        <div className={styles["col-sm-8"]}>
          <textarea
            className={styles["note-textarea"]}
            value={data.KriterienNotiz || ""}
            onChange={(e) => setData((prev) => ({
              ...prev,
              KriterienNotiz: e.target.value.slice(0, 200),
            }))}
            placeholder="Kriterien-Notiz"
            maxLength={200}
            rows={4}
          />
          <p >
            Verbleibende Zeichen: {200 - (data.KriterienNotiz || "").length}
          </p>
        </div>
      </div>

      <div id="kategorisierung_output"></div>

      <div className={`${styles.row} ${styles.actions}`}>
        <button
          type="button"
          className={styles["btn-primary"]}
          onClick={handleBack}
        >
          Zurück
        </button>
        <button
          type="button"
          className={styles["btn-primary"]}
          onClick={handleNext}
        >
          Weiter
        </button>
      </div>
    </div>
  );
};

export default Kriterien;